export default function Marquee({ items = [], slow = false, testId }) {
  const doubled = [...items, ...items];
  return (
    <div
      data-testid={testId}
      className="overflow-hidden py-8 border-y border-black/10"
    >
      <div
        className={`flex w-max sba-marquee-track ${slow ? "sba-marquee-track--slow" : ""}`}
      >
        {doubled.map((it, i) => (
          <div
            key={`${it}-${i}`}
            className="px-12 flex items-center shrink-0"
            aria-hidden={i >= items.length}
          >
            <span className="font-serif italic text-2xl md:text-3xl text-[#1a1a1a]/80 whitespace-nowrap">
              {it}
            </span>
            <span className="mx-8 w-1.5 h-1.5 rounded-full bg-[#1a1a1a]/30" />
          </div>
        ))}
      </div>
    </div>
  );
}
